export default "__VITE_ASSET__CvbRossd__"